import { useRef, useState, useEffect } from "react";
import classnames from "classnames";
import { useOnClickOutside } from "../../customHooks/useOnClickOutside";
import HeaderMultiSelectItem from "./HeaderMultiSelectItem";

interface Props {
    options: any;
    onChange: any;
}

require("./HeaderMultiSelect.css");

const HeaderMultiSelect = (props: Props) => {

    const [options, setOptions] = useState(props.options);
    const [show, setShow] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState(Array());

    const ref = useRef(null);

    useOnClickOutside(ref, () => {
        setShow(false);
    });

    const handleShowFilters = () => {
        setShow(!show);
    }

    const handleRemoveFilters = () => {
        const newOptions = options;
        newOptions.forEach((o) => {
            o.selected = false;
        });
        setSelectedOptions([]);
        setOptions(options);
        props.onChange([]);
    }

    const handleChange = (option: any) => {
        const newSelected = selectedOptions;
        if (option.selected) {
            const o = newSelected.find((op: any) => { return op.name === option.name; });
            if (!o) {
                newSelected.push(option);
            }
        }
        else {
            const index = newSelected.findIndex(op => op.name === option.name);
            if (index > -1) {
                newSelected.splice(index, 1);
            }
        }
        setSelectedOptions(newSelected);
        setShow(!show);
        props.onChange(newSelected);
    }

    return <div>
        <i className="fas fa-filter" onClick={handleShowFilters}></i>
        {selectedOptions.length > 0 && <i className="fas fa-times" onClick={handleRemoveFilters}></i>}
        {show && options && options.length && <div className="header-options" ref={ref}>
            {options.map((o, i) => {
                return <HeaderMultiSelectItem
                    option={o}
                    onChange={handleChange}
                    index={i}
                />
            })}
        </div>}
    </div>
}

export default HeaderMultiSelect;